import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "organisationName",
  class: "form-label"
}, "Name", -1)
const _hoisted_4 = ["readonly"]
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "organisationIdentifier",
  class: "form-label"
}, "Url", -1)
const _hoisted_8 = ["readonly"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = {
  id: "formattedUrl",
  class: "form-text mb-3"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-5" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "validationType",
  class: "form-label"
}, "Validation Type", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-7" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "validationExample",
  class: "form-label"
}, "Example", -1)
const _hoisted_18 = ["readonly"]
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Create Organisation ")

import {
  computed,
  onMounted,
  Ref,
  ref,
  watch,
} from "vue";
import { getFunctions } from "firebase/functions";
import { ValidationError, validationMessage } from "@/model/validation-error";
import { Organisation, Validation, ValidationType } from "@/model/organisation";
import ModalView from "@/components/ModalView.vue";
import { ApiService } from "@/api-service";


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
}

let organisationName: Ref<string | null> = ref(null);
let organisationNameError: Ref<string | null> = ref(null);
let organisationIdentifier: Ref<string | null> = ref(null);
let organisationIdentifierError: Ref<string | null> = ref(null);
let validationExample: Ref<string | null> = ref("ABC123");
let validationExampleError: Ref<string | null> = ref(null);
let selectedValidationType: Ref<ValidationType> = ref(ValidationType.idCode);
let validationTypeOptions: Ref<ValidationType[]> = ref([
  ValidationType.email,
  ValidationType.idCode,
]);
let loading: Ref<boolean> = ref(false);

const formattedUrl = computed(() => {
  let organisationPlaceholder = organisationIdentifier.value;
  if (!organisationPlaceholder || organisationPlaceholder == "") {
    organisationPlaceholder = "organisation";
  }
  return `https://${organisationPlaceholder}.thepeoplespot.com`;
});



const apiService = new ApiService(getFunctions());



async function createOrganisation() {
  let hasError = false;
  if (
    organisationIdentifier.value == null ||
    organisationIdentifier.value == ""
  ) {
    organisationIdentifierError.value = "Required";
    hasError = true;
  }

  if (organisationName.value == null || organisationName.value == "") {
    organisationNameError.value = "Required";
    hasError = true;
  }

  if (validationExample.value == null || validationExample.value == "") {
    validationExampleError.value = "Required";
    hasError = true;
  }

  if (hasError) {
    return;
  }

  loading.value = true;
  await apiService
    .createOrganisation(
      new Organisation(
        organisationIdentifier.value!,
        organisationName.value!,
        true,
        true,
        new Validation(selectedValidationType.value, validationExample.value!)
      )
    )
    .then(() => {
      emit("hide-modal");
    })
    .catch((error) => {
      console.log("createOrganisation failed", error);
      if (error.details) {
        let validationErrors = error.details as ValidationError[];
        for (let validationError of validationErrors) {
          switch (validationError.field) {
            case "organisationIdentifier": {
              organisationIdentifierError.value = validationMessage(
                validationError.reason
              );
              break;
            }
            case "name": {
              organisationNameError.value = validationMessage(
                validationError.reason
              );
              break;
            }
            case "example": {
              validationExampleError.value = validationMessage(
                validationError.reason
              );
              break;
            }
          }
        }
      }
    });

  loading.value = false;
}

onMounted(() => {
  selectedValidationType.value = ValidationType.idCode;
});

watch(
  () => props.isVisible,
  (visible: boolean) => {
    if (visible) {
      organisationName.value = null;
      organisationIdentifier.value = null;
    }
  }
);

watch(
  () => organisationName.value,
  () => {
    organisationNameError.value = null;
  }
);

watch(
  () => organisationIdentifier.value,
  () => {
    organisationIdentifierError.value = null;
  }
);

watch(
  () => selectedValidationType.value,
  (selectedValidationType) => {
    switch (selectedValidationType) {
      case ValidationType.email: {
        validationExample.value = "demo@thepeoplespot.com";
        break;
      }
      case ValidationType.idCode: {
        validationExample.value = "ABC123";
        break;
      }
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    onHideModal: _cache[4] || (_cache[4] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn-close", { disabled: _unref(loading) }]),
        "data-bs-dismiss": "modal",
        "aria-label": "Close"
      }, null, 2)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(organisationNameError) }]),
            id: "organisationName",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(organisationName) ? (organisationName).value = $event : organisationName = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_4), [
            [_vModelText, _unref(organisationName)]
          ]),
          (_unref(organisationNameError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(organisationNameError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(organisationIdentifierError) }]),
            id: "organisationIdentifier",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(organisationIdentifier) ? (organisationIdentifier).value = $event : organisationIdentifier = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_8), [
            [_vModelText, _unref(organisationIdentifier)]
          ]),
          (_unref(organisationIdentifierError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(organisationIdentifierError)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formattedUrl)), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select", { disabled: _unref(loading) }]),
                id: "validationType",
                required: "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedValidationType) ? (selectedValidationType).value = $event : selectedValidationType = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validationTypeOptions), (validationType) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: validationType,
                    key: validationType
                  }, _toDisplayString(validationType), 9, _hoisted_15))
                }), 128))
              ], 2), [
                [_vModelSelect, _unref(selectedValidationType)]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _unref(validationExampleError) }]),
              id: "validationExample",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(validationExample) ? (validationExample).value = $event : validationExample = $event)),
              readonly: _unref(loading)
            }, null, 10, _hoisted_18), [
              [_vModelText, _unref(validationExample)]
            ]),
            (_unref(validationExampleError) != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(validationExampleError)), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary", { disabled: _unref(loading) }]),
        onClick: createOrganisation
      }, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_20))
          : _createCommentVNode("", true),
        _hoisted_21
      ], 2)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})